export const defaultWidth = 368;